import React from "react";
import { SecurityBanner } from "../../blocks/security-banner";
// import { CommonBanner } from "../../blocks/common-banner";
import { SecurityStrategy } from "../../blocks/security-strategy";
import { SecurityCompliance } from "../../blocks/security-compliance";
import { Header } from "../../components/Header";
import { BlockTry } from "../../blocks/common-blocktry";
// import { Helmet } from "react-helmet";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { CommonLinkPage } from "../../blocks/common-link-page";
import { CommonPageLink } from "../../blocks/common-page-link";
import { Footer } from "../../components/FooterV2";
import { Helmet } from "react-helmet";

export const SecurityPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  return (
    <div className="security-page">
      <Helmet>
        <title>
          Authing安全与合规-一站式身份认证-零信任网络-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode={"light"} />
      <SecurityBanner />
      <SecurityStrategy />
      <SecurityCompliance />
      <CommonPageLink pagesLink={pagesLink} />
      <BlockTry />
      <Footer />
    </div>
  );
};
